import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    input: {
        width: "429px",
        color: theme.palette.text.primary,
    },
    label: {
        color: theme.palette.text.primary,
    },
}));
